/*
  Main App component with all the routes
*/

import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; 
import Dashboard from './pages/Dashboard';
import Login from './pages/Login'; 
import Team from './pages/Team'
import Setup from './pages/Setup';
import AddUser from './pages/AddUsers';
import Segmentationbeta from './pages/Segmentationbeta'
import CompareAnalyses from './pages/CompareAnalyses'
import { ErrorBoundary } from './components/ErrorBoundary'


function App() {
  return (
    <ErrorBoundary>
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/team" element={<Team />} />
        <Route path="/setup" element={<Setup />} />
        <Route path="/adduser" element={<AddUser />} />
        <Route path="/segmentation" element={<Segmentationbeta />} />
        <Route path="/segmentationbeta" element={<Segmentationbeta />} />
        <Route path="/compare" element={<CompareAnalyses />} />

      </Routes>
    </Router>
    </ErrorBoundary>
  );
}

export default App;
